<template>
	<div class="bg-gray-200 p-4">
		<h2 class="text-center" v-html="ppcData.marketing_block_sub_heading"></h2>
		<p class="text-sm text-center mb-8">
			{{ ppcData.marketing_block_question }}
		</p>
		<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
			<div v-for="(block, index) in marketingBlocks" :key="index" class="mx-auto px-6">
				<img loading="lazy" v-if="block.image" class="mx-auto" :src="`${urlLocation}${block.image}`"
					:alt="block.heading" />
				<h4 class="text-center my-4">
					{{ block.heading }}
				</h4>
				<p class="text-center text-sm">
					{{ block.copy }}
				</p>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
const props = defineProps({
	ppcData: {
		type: Object,
		required: true,
	},
	urlLocation: {
		type: String,
		required: true,
	},
});

const marketingBlocks = computed(() => {
	return [
		{
			image: props.ppcData.marketing_block_1_image,
			heading: props.ppcData.marketing_block_1_heading,
			copy: props.ppcData.marketing_block_1_copy,
		},
		{
			image: props.ppcData.marketing_block_2_image,
			heading: props.ppcData.marketing_block_2_heading,
			copy: props.ppcData.marketing_block_2_copy,
		},
		{
			image: props.ppcData.marketing_block_3_image,
			heading: props.ppcData.marketing_block_3_heading,
			copy: props.ppcData.marketing_block_3_copy,
		},
	];
});
</script>

<style scoped>
/* Add any scoped styles specific to this component */
</style>
